import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';

export default class OverlayNavigation {
    constructor() {
        this.progress = false;
        this.init();
    }

    init() {
        var hamburger = document.querySelector( '.hamburger' ),
            navigation = document.querySelector( '.overlay-navigation' );

        if ( hamburger === null ) {
            return;
        }

        hamburger.addEventListener( 'click', ( e ) => {
            e.preventDefault();
            
            if ( this.progress !== true ) {
                this.progress = true;

                if ( document.body.classList.contains( 'navigation-opened' ) ) {
                    enableBodyScroll( navigation );
                    document.body.classList.add( 'navigation-opened-end' );
                    document.body.classList.remove( 'navigation-opened' );

                    setTimeout( () => {
                        document.body.classList.remove( 'navigation-opened-end' );
                        hamburger._tippy.setContent( hamburger.getAttribute( 'data-tooltip-open' ) );
                        hamburger._tippy.hide();
                    }, 1650 );
                } else {
                    disableBodyScroll( navigation );
                    document.body.classList.add( 'navigation-opened' );
                    hamburger._tippy.setContent( hamburger.getAttribute( 'data-tooltip-close' ) );
                    hamburger._tippy.hide();
                }

                this.progress = false;
            }
        } );

        let windowWidth = window.innerWidth;

        window.addEventListener( 'resize', ( e ) => {
            if( windowWidth !== window.innerWidth ) {
                windowWidth = window.innerWidth;

                document.body.classList.remove( 'navigation-opened', 'navigation-opened-end' );
                clearAllBodyScrollLocks();
            }
        } );
    }
}
